import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { notify } from 'components/Common/Toast';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { AnnouncementGroupDetailState, RemoveGroupMember } from 'types/announcements';
import { ID } from 'types/common';

const initialState: AnnouncementGroupDetailState = {
    members: [],
    details: null,
    membersLoading: false,
    detailsLoading: false,
    error: null,
    groupName: null,
    groupImage: null,
};

export const fetchAnnouncementGroupDetail = (id: ID) => (dispatch: any) => {
    dispatch(fetchAnnouncementGroupInformation(id));
    dispatch(fetchAnnouncementGroupMembers(id));
};

export const fetchAnnouncementGroupInformation = createAsyncThunkWrapper<any, ID>(
    'groupDetails/fetchAnnouncementGroupDetails',
    async (id: ID) => {
        const response: any = await client.get(`/getAnnouncementGroup/${id}`);
        const { announcementGroup, totalParticipants } = response || {};
        return { ...announcementGroup, totalParticipants };
    }
);

export const fetchAnnouncementGroupMembers = createAsyncThunkWrapper<any, ID>(
    'groupDetails/fetchAnnouncementGroupMembers',
    async (id: ID) => {
        let response: any = await client.get(`/getAnnouncementGroupUserList/${id}`);
        return response?.userList;
    }
);

export const removeMemberFromGroup = createAsyncThunkWrapper<any, RemoveGroupMember>(
    'groupDetails/removeMemberFromGroup',
    async (data: RemoveGroupMember, { dispatch }) => {
        let response: any = await client.delete(`/deleteAnnouncementGroupUser`, { data: data });
        if (response.code === 200) {
            notify('Member Removed Successfully', 'success');
            dispatch(fetchAnnouncementGroupDetail(String(data.announcementGroupId)));
        }
        return response;
    }
);

const announcementGroupDetailSlice = createSlice({
    name: 'groupDetailsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAnnouncementGroupInformation.pending, (state) => {
            state.detailsLoading = true;
        });
        builder.addCase(fetchAnnouncementGroupInformation.fulfilled, (state, action) => {
            state.detailsLoading = false;
            const { payload } = action;
            if (!payload) return;
            state.details = payload;
        });
        builder.addCase(fetchAnnouncementGroupInformation.rejected, (state) => {
            state.detailsLoading = false;
        });
        builder.addCase(fetchAnnouncementGroupMembers.pending, (state) => {
            state.membersLoading = true;
        });
        builder.addCase(fetchAnnouncementGroupMembers.fulfilled, (state, action) => {
            state.membersLoading = false;
            const { payload } = action;
            if (!payload) return;
            state.members = payload;
        });
        builder.addCase(fetchAnnouncementGroupMembers.rejected, (state) => {
            state.membersLoading = false;
        });
    },
});
export default announcementGroupDetailSlice.reducer;
